go-to-top {
  /**
    @prop --go-to-top-right:
      Right position of the button.
      - default: 2rem
  */
  --go-to-top-right: 2rem;

  /**
    @prop --go-to-top-bottom:
      Bottom position of the button.
      - default: 2rem
  */
  --go-to-top-bottom: 2rem;

  display: block;
  position: fixed;
  bottom: var(--go-to-top-bottom);
  right: var(--go-to-top-right);
  pointer-events: none;
  z-index: var(--layer-important);
  opacity: 0;
  transform: scale(0);
  @include transition(transform, opacity);
  &.active {
    pointer-events: inherit;
    transform: scale(1);
    opacity: 1;
  }
}
